/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CourseDto = {
    id?: string;
    agentId?: string;
    title?: string;
    description?: string;
    imageUrl?: string;
    language?: CourseDto.language;
};
export namespace CourseDto {
    export enum language {
        EN = 'EN',
        DE = 'DE',
    }
}

